__webpack_require__.p = "https://uat.restaurants.plateron.com/";